<template>
  <v-menu v-model="isOpen" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y
    min-width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field dense :error="!!error" :error-messages="error" :value="formatDate(newDate)" :label="label"
        append-icon="event" readonly clearable @click:clear="onClearDate" v-bind="attrs" v-on="on"></v-text-field>
    </template>
    <v-date-picker type="date" :value="newDate" @input="onSetDate" locale="es-GT"
      :first-day-of-week="1"></v-date-picker>
  </v-menu>
</template>

<script>
import { toUTC } from '../../services/timeUtils'
export default {
  props: {
    label: String,
    date: [Number, String],
    error: String
  },
  created() {
    this.newDate = this.dateToStr(this.date)
  },
  data() {
    return {
      newDate: null,
      isOpen: false
    }
  },
  watch: {
    date() {
      if (this.date === null) {
        this.newDate = this.dateToStr(this.date)
      }
    }
  },
  methods: {
    onSetDate(date) {
      this.isOpen = false
      this.newDate = date
      const dateArr = date.split('-')
      const dateLocal = new Date()
      dateLocal.setFullYear(+dateArr[0])
      dateLocal.setMonth(parseInt(dateArr[1]) - 1)
      dateLocal.setDate(parseInt(dateArr[2]))
      dateLocal.setHours(0, 0, 0, 0)
      this.$emit('onChangeDate', dateLocal.valueOf())
    },
    dateToStr(date) {
      if (typeof date === 'string' || typeof date === 'number') date = new Date(date)
      if (!date) return null
      // toUTC(date)
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${date.getFullYear()}-${month >= 10 ? month : '0' + month}-${day >= 10 ? day : '0' + day}`
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const dates = dateStr.split('-')
      return `${dates[2]}-${dates[1]}-${dates[0]}`
    },
    onClearDate() {
      this.newDate = null
      this.$emit('onChangeDate', null)
    }
  },
}
</script>

<style></style>